### global require, ga, _hmt ###

browser = undefined
require 'plugins/pure/pure-min.css'
require 'plugins/icomoon/style.css'
require 'plugins/flexslider/flexslider.css'
require 'styles/common/util.scss'
require 'styles/common/common1.scss'
require 'styles/pages/zfb.scss'

require 'script!jquery'
require '../common/form-validation.coffee'
require 'script!flexslider'
require 'script!sweetAlert'
require 'script!ajaxform'
require 'script!affix'
require '../common/fast-nav.coffee'
require '../common/city.coffee'
require 'script!inputmask'

browser =
  isIE8: !!navigator.userAgent.match(/MSIE 8.0/)
  isIE9: !!navigator.userAgent.match(/MSIE 9.0/)
do ->
  $fixedshenqing=$('.fixed-shenqing')
  if $fixedshenqing.length>0
    $(window).scroll ->
      scrollTop = $(window).scrollTop()
      if  480<= scrollTop
        $fixedshenqing.stop().animate(bottom:0,50)
      else
        $fixedshenqing.stop().animate(bottom:-85,50)
# 报价部分js
do ->
  if $('#indextop').length > 0
    $form = $('#indextop')
    $truename = $form.find '[name="truename"]'
    $mobile = $form.find '[name="mobile"]'
    # 表单验证
    $form.validate
      errorPlacement: (error, element)->
        swal {
          title: error[0].innerHTML
          allowOutsideClick: false
        }
      submitHandler: (form)->
        phoneNumber=form.elements.mobile.value.trim()
        userId="MOBI#{phoneNumber}"
        $(form).ajaxSubmit {
          dataType: 'json'
          data: {
            rnd: parseInt(Math.random()*1e7,10)+(new Date()).getTime()
          }
          error: ->
            swal {
              title: '对不起，出错了，请稍后重试！'
              allowOutsideClick: true
            }
          success: (res)->
            $options1=$("#quota option:selected")
            $val1=$options1.val()
            if $val1 is "0"
              swal {
                title: '请填写申请额度！'
                allowOutsideClick: true
              }
              return false

            if res.msg?[0]?.type is 'success'
              swal({
                customClass: 'alert-success',
                title: '<img class="form_success" src="http://p.51zx.com/FuK_TJTSwVZBR7Ho2nAj1_z3THKw" alt="">',
                confirmButtonText: '返  回',
                confirmButtonColor: '#3b9bff',
                allowOutsideClick: true,
                html: true,
                timer:1000000
              })
            if res.msg[0].type is 'error'
              swal {
                title: res.msg[0].info
                allowOutsideClick: true
              }
              return false
        }
        return false

    $mobile.rules 'add',
      required: true
      mobileNum: true
      messages:
        required: '请输入11位手机号码'
        mobileNum: '请输入正确的手机号'
    return false

#计算贷款额度
do->
  $calculate=$('#calculate')
  $loanAmount=$('#loanAmount')
  $cycle=$('#cycle')
  $monthlyRepayment=$('#monthlyRepayment')
  $loanAmount1=$('#loanAmount1')
  $cycle1=$('#cycle1')
  $total=$('#total')
  $error=$("#error")

  $loanAmount.blur ->
    $loanAmountval = $loanAmount.val()
    if not $loanAmountval
      $loanAmount.css("border":"1px solid #f53353")
      $error.css("color":"#f53353")
      $error.text("请输入贷款金额")
    else if $loanAmountval>160000
      $loanAmount.css("border":"1px solid #f53353")
      $error.css("color":"#f53353")
      $error.text("贷款金额不能高于16万元")
      return false
    else if $loanAmountval<10000
      $loanAmount.css("border":"1px solid #f53353")
      $error.css("color":"#f53353")
      $error.text("贷款金额不能低于1万元")
      return false
    else
      $loanAmount.css("border":"1px solid #e9ecf0")
      $error.css("color":"#fff")
    $loanAmount1.text($loanAmountval)

  $calculate.click ->
    $loanAmountval = $loanAmount.val()
    $options=$("#cycle option:selected")
    $val=$options.val()

    if not $loanAmountval
      swal {
        title:"请输入贷款金额"
        allowOutsideClick: true
      }
      return false
    else if $loanAmountval>160000
      swal {
        title:"贷款金额不能高于16万元"
        allowOutsideClick: true
      }
      return false
    else if $loanAmountval<10000
      swal {
        title:"贷款金额不能低于1万元"
        allowOutsideClick: true
      }
      return false

    if $val is "6"
      monthlyRepayment=$loanAmountval*0.0065 + $loanAmountval/6
      $monthlyRepayment.text(monthlyRepayment.toFixed(2))
      $cycle1.text(6)
      $total.text((monthlyRepayment*6).toFixed(2))
    else if $val is "12"
      monthlyRepayment=$loanAmountval*0.0065 + $loanAmountval/12
      $monthlyRepayment.text(monthlyRepayment.toFixed(2))
      $cycle1.text(12)
      $total.text((monthlyRepayment*12).toFixed(2))
    else if $val is "18"
      monthlyRepayment=$loanAmountval*0.0065 + $loanAmountval/18
      $monthlyRepayment.text(monthlyRepayment.toFixed(2))
      $cycle1.text(18)
      $total.text((monthlyRepayment*18).toFixed(2))
    else if $val is "24"
      monthlyRepayment=$loanAmountval*0.0065 + $loanAmountval/24
      $monthlyRepayment.text(monthlyRepayment.toFixed(2))
      $cycle1.text(24)
      $total.text((monthlyRepayment*24).toFixed(2))
    else if $val is "36"
      monthlyRepayment=$loanAmountval*0.0065 + $loanAmountval/36
      $monthlyRepayment.text(monthlyRepayment.toFixed(2))
      $cycle1.text(36)
      $total.text((monthlyRepayment*36).toFixed(2))
    else if $val is "48"
      monthlyRepayment=$loanAmountval*0.0065 + $loanAmountval/48
      $monthlyRepayment.text(monthlyRepayment.toFixed(2))
      $cycle1.text(48)
      $total.text((monthlyRepayment*48).toFixed(2))
    else if $val is "60"
      monthlyRepayment=$loanAmountval*0.0065 + $loanAmountval/60
      $monthlyRepayment.text(monthlyRepayment.toFixed(2))
      $cycle1.text(60)
      $total.text((monthlyRepayment*60).toFixed(2))
    else
      swal {
        title:$val
        allowOutsideClick: true
      }
      return false





/** WEBPACK FOOTER **
 ** /root/workspace/jimujia-pc_4ez2/wwwroot/static/~/coffeelint-loader!./zfb.coffee
 **/